<template>
    <ModalComponent
        name="add-puerta"
        title="Añadir puerta"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="crearPuerta()">
            <div class="row">
                <div class="col-12">
                    <FormInput label="Nombre" name="nombre" type="text" rules="required" v-model="data.nombre" />
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <Button type="submit" name="button" id="submit-sale-ad">Continuar</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['evento_id'],
        data() {
            return {
                data: {
                    time_lapse: 0,
                    event_id: this.evento_id
                }
            }
        },
        methods: {
            close(editado) {
                this.$emit('close', 'add-puerta', editado);
            },
            crearPuerta() {
                this.data.filters = {};
                this.data.evento_id = this.evento_id;

                this.$store.dispatch(this.config.getVuexAlias('back.events.puertas.crear'), this.data).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                    this.loading = false;
                });
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
